var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.141176 0 0 0 0 0.152941 0 0 0 0 0.180392 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "M0 0H64V64H0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M13.262 48.762C6.005 48.72.002 33.906.002 26.36c0-12.324 9.245-15.022 12.808-15.022 1.606 0 3.32.63 4.833 1.188 1.057.39 2.151.791 2.76.791.364 0 1.222-.342 1.98-.641 1.615-.644 3.625-1.443 5.966-1.443h.014c1.748 0 7.048.384 10.234 5.169l.747 1.121-1.075.811c-1.534 1.158-4.334 3.27-4.334 7.454 0 4.955 3.17 6.861 4.694 7.778.673.404 1.369.821 1.369 1.734 0 .595-4.755 13.387-11.659 13.387-1.69 0-2.884-.508-3.937-.956-1.066-.453-1.985-.844-3.504-.844-.77 0-1.744.364-2.775.751-1.41.526-3.004 1.123-4.813 1.123h-.048zM29.08 0c.18 6.483-4.457 10.981-9.088 10.7C19.23 5.524 24.622 0 29.08 0z",
    transform: "translate(12 7)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSquare);
export default __webpack_public_path__ + "static/media/appleSquare.e60bd25e8d784d54c188458056c1b333.svg";
export { ForwardRef as ReactComponent };